import { useRef, useState } from "react";
import { toast } from "react-toastify";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";

const FileUploader = ({
  label = "Upload File",
  inputId = "file-upload",
  accept = "image/*,application/pdf",
  file = null,
  existingId = null,
  onFileChange,
  onRemoveFile,
  isEdit,
  onDeleteDocument,
}) => {
  const fileInputRef = useRef(null);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const handleUploadClick = (e) => {
    if (file) {
      e.preventDefault();
      toast.warning("Please delete existing document before selecting new one");
      return;
    }
    fileInputRef.current?.click();
  };

  return (
    <div className="col-12 col-md-6 col-lg-5">
      <div className="form-group mb-3">
        <label className="form-label" htmlFor={inputId}>
          Upload {label}
          <span className="text-danger">*</span>
        </label>

        {/* Hidden File Input */}
        <input
          type="file"
          className="form-control d-none"
          id={inputId}
          ref={fileInputRef}
          accept={accept}
          onChange={(e) => {
            const selectedFile = e.target.files[0];
            if (selectedFile && selectedFile.size > 6 * 1024 * 1024) {
              toast.error("File size must be less than 6MB");
              e.target.value = "";
              return;
            }
            onFileChange(e);
          }}
        />

        {/* Custom File Upload Trigger */}
        <label
          onClick={handleUploadClick}
          className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
          style={{
            display: "inline-block",
            cursor: "pointer",
            padding: 5,
            backgroundColor: "rgb(245, 245, 245)",
            borderRadius: 8,
            minWidth: 150,
          }}
        >
          <div className="d-flex flex-column">
            <span className="placeholder-img">
              <UploadPlusIcon />
            </span>
            <span className="text-muted">Choose File</span>
          </div>
        </label>

        {/* Uploaded File Preview */}
        <div className="preview-section p-1 mt-3">
          {file && (
            <div
              className="d-flex align-items-center justify-content-between p-3 border rounded mb-2"
              style={{ backgroundColor: "#f8f9fa", cursor: "pointer" }}
            >
              <div
                className="w-100"
                onClick={() => {
                  const docUrl = {
                    url: file?.url,
                  };
                  console.log(file);
                  setSelectedDocument(isEdit ? docUrl : file);
                  toggleModal();
                }}
              >
                <span>{file?.name}</span>
              </div>
              <button
                type="button"
                className="text-danger mx-2 bg-light"
                onClick={() => onRemoveFile(existingId, file?.key)}
              >
                <DeleteIcon />
              </button>
            </div>
          )}
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </div>
  );
};

export default FileUploader;
